import React, { useMemo, useRef } from 'react';
import { formatVideoTime, useVideoPlayer } from '../catering-landing-utils';
import PauseMedia from '@ps-design-system/icons/PauseMedia/PauseMedia24';
import PlayMedia from '@ps-design-system/icons/PlayMedia/PlayMedia24';

export const CateringLandingVideoPlayer = () => {
  const videoRef = useRef(null);
  const {
    handleLoad,
    currentSecond,
    handleTimeUpdate,
    play,
    playing,
    playHandler,
    totalSeconds,
    pauseHandler,
    pause
  } = useVideoPlayer(videoRef);

  const togglePlay = () => {
    playing ? pause() : play();
  };

  const formattedTime = useMemo(() => `${formatVideoTime(currentSecond)} / ${formatVideoTime(totalSeconds)}`, [currentSecond, totalSeconds]);

  return (
    <div className="catering-landing-video-player" onClick={togglePlay}>
      <video
        ref={videoRef}
        className="catering-landing-video"
        id="catering_test_reel_v3"
        preload="metadata"
        onPlay={playHandler}
        onPause={pauseHandler}
        onTimeUpdate={handleTimeUpdate}
        onCanPlay={handleLoad}
        playsInline
        autoPlay={false}
        controls={false}
      >
        <source src="https://img.peerspace.com/video/upload/q_50/v1730916891/catering/catering_test_reel_v3.mp4#t=0.1" type="video/mp4" />
      </video>
      <div className="catering-landing-video-controls absolute flex middle">
        <button
          className="toggle-video-button margin-sm-right flex"
          type="button"
          onClick={togglePlay}
        >
          {playing
            ? <PauseMedia />
            : <PlayMedia />
          }
        </button>
        <div className="text-white heavier">{formattedTime}</div>
      </div>
    </div>
  );
};
